import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { Anime, Video } from '../models/core.model';
import animeList from 'assets/database/animeList.json';
declare var require: any;

@Injectable()
export class AnimeListService {
    get(anime: string = null): Observable<any> {
        if (anime != null) {
            return of(animeList.data.find(x => x.Route.toLowerCase() == anime.toLowerCase()));
        }
        return of(animeList.data);
    }

    getEpisodes(anime: string): Observable<Video[]> {
        return of(require(`assets/database/${anime}/list`));
    }

    getEpisode(anime: string, episode: string): Observable<Video> {
        return of(require(`assets/database/${anime}/list`).find(x => x.Ep == parseInt(episode)));
    }
}